export default class AlertDialog {
    static show(message) {
        alert(message);        
    }
}